/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientGroupItemDto } from './GetClientGroupItemDto';
import {
    GetClientGroupItemDtoFromJSON,
    GetClientGroupItemDtoFromJSONTyped,
    GetClientGroupItemDtoToJSON,
} from './GetClientGroupItemDto';

/**
 * 
 * @export
 * @interface GetClientGroupDto
 */
export interface GetClientGroupDto {
    /**
     * 
     * @type {string}
     * @memberof GetClientGroupDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetClientGroupDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetClientGroupDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetClientGroupDto
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetClientGroupDto
     */
    active: boolean;
    /**
     * 
     * @type {Array<GetClientGroupItemDto>}
     * @memberof GetClientGroupDto
     */
    items?: Array<GetClientGroupItemDto>;
}

/**
 * Check if a given object implements the GetClientGroupDto interface.
 */
export function instanceOfGetClientGroupDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetClientGroupDtoFromJSON(json: any): GetClientGroupDto {
    return GetClientGroupDtoFromJSONTyped(json, false);
}

export function GetClientGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'active': json['active'],
        'items': !exists(json, 'items') ? undefined : ((json['items'] as Array<any>).map(GetClientGroupItemDtoFromJSON)),
    };
}

export function GetClientGroupDtoToJSON(value?: GetClientGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'description': value.description,
        'active': value.active,
        'items': value.items === undefined ? undefined : ((value.items as Array<any>).map(GetClientGroupItemDtoToJSON)),
    };
}

